import React, { useState } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import './SelectAll.css';
import { injectIntl } from 'react-intl';

export const actions = {
  SELECT_ALL: 'select_all',
  UNSELECT_ALL: 'unselect_all',
  SELECT_ACTIVES: 'select_actives',
  SELECT_INACTIVES: 'select_inactives',
  UNSELECT_ACTIVES: 'unselect_actives',
};

export const checkStates = {
  SELECTED: 'selected',
  UNSELECTED: 'unselected',
  INDETERMINATE: 'indeterminate',
};

const SelectAll = ({
  intl,
  showDivider = true,
  selected_items: selectedItems,
  showActivesFilters = false,
  onCheckboxClick,
  onActiveCheckboxClick,
  total = 0,
}) => {
  const [selects, setSelects] = useState({ active: false, inactive: false });
  const [values, setValues] = useState({ active: checkStates.UNSELECTED, inactive: checkStates.UNSELECTED })
  
  const selectAllLabel = intl.messages['select_all.select_items'];
  const selectActivesLabel = intl.messages['select_all.select_active_items'];
  const selectInactivesLabel = intl.messages['select_all.select_inactive_items'];

  const handleChange = (event) => {
    if (event.target.value === checkStates.SELECTED) {
      onCheckboxClick(actions.UNSELECT_ALL);
      setSelects({ active: false, inactive: false });
      setValues({ active: checkStates.UNSELECTED, inactive: checkStates.UNSELECTED });
    } else if (event.target.value === checkStates.UNSELECTED) {
      onCheckboxClick(actions.SELECT_ALL);
    } else if (event.target.value === checkStates.INDETERMINATE) {
      onCheckboxClick(actions.UNSELECT_ALL);
      setSelects({ active: false, inactive: false });
      setValues({ active: checkStates.UNSELECTED, inactive: checkStates.UNSELECTED });
    }
  };

  const handleActivesChange = (event, isActive) => {
    setSelects({ active: isActive && selects.active ? false : isActive, inactive: !isActive && selects.inactive ? false : !isActive });
    setValues({
      active: isActive ? checkStates.SELECTED : checkStates.UNSELECTED,
      inactive: !isActive ? checkStates.SELECTED : checkStates.UNSELECTED
    });

    if (event.target.value === checkStates.SELECTED) {
      onActiveCheckboxClick(actions.UNSELECT_ACTIVES);
    } else {
      onActiveCheckboxClick(isActive ? actions.SELECT_ACTIVES : actions.SELECT_INACTIVES);
    }
  };

  const checkSelected = () => {
    const selected = Object.values(selectedItems).filter(id => id).length;

    if (selected >= total && total !== 0) {
      return (
        <Checkbox
          color="primary"
          checked="true"
          onClick={handleChange}
          value={checkStates.SELECTED}
        />
      );
    } else if (selected === 0) {
      return (
        <Checkbox
          color="primary"
          onClick={handleChange}
          value={checkStates.UNSELECTED}
        />
      );
    } else {
      return (
        <Checkbox
          color="primary"
          checked="false"
          indeterminate
          onClick={handleChange}
          value={checkStates.INDETERMINATE}
        />
      );
    }
  };

  return (
    <div className="select-all-div">
      <div className="checkbox-div">
        <div>{checkSelected(selectedItems)}</div>
        <div className="select-all-label">
          <p>{selectAllLabel}</p>
        </div>
      </div>
      {
        showActivesFilters && (
          <>
            <div className="checkbox-div">
              <div>
                <Checkbox
                  color="primary"
                  checked={selects.active}
                  onClick={(e) => handleActivesChange(e, true)}
                  value={values.active}
                />
              </div>
              <div className="select-all-label">
                <p>{selectActivesLabel}</p>
              </div>
            </div>
            <div className="checkbox-div">
              <div>
                <Checkbox
                  color="primary"
                  checked={selects.inactive}
                  onClick={(e) => handleActivesChange(e, false)}
                  value={values.inactive}
                />
              </div>
              <div className="select-all-label">
                <p>{selectInactivesLabel}</p>
              </div>
            </div>
          </>
        )
      }
      {showDivider && <Divider />}
    </div>
  );
};

export default injectIntl(SelectAll);